// extracted by mini-css-extract-plugin
module.exports = {"base":"Content_base__2gPaa"};